<template>
  <div>
    <div class="button-group">
      <button
        class="btn"
        @click="updatePrintType('nb')"
        :class="{ active: localFileDetails.printType === 'nb' }"
      >
        Noir et Blanc <br />{{ fileDetails.price_bw }}€
      </button>
      <button
        class="btn"
        @click="updatePrintType('color')"
        :class="{ active: localFileDetails.printType === 'color' }"
      >
        Couleur <br />{{ fileDetails.price_color }}€
      </button>
    </div>
    <div class="button-group">
      <button
        class="btn"
        @click="updateRectoVerso(false)"
        :class="{ active: localFileDetails.rectoverso === false }"
      >
        Simple page
      </button>
      <button
        class="btn"
        @click="updateRectoVerso(true)"
        :class="{ active: localFileDetails.rectoverso === true }"
      >
        Recto verso
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fileDetails: {
      type: Object,
      required: true,
    },
    selectedPrinter: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      localFileDetails: {
        ...this.fileDetails,
        printType: "nb", // Initialisation par défaut
        rectoverso: false,
        selectedPrinter: 0,
        price: 0,
      },
    };
  },
  watch: {
    fileDetails: {
      immediate: true, // Mettre à jour immédiatement au montage
      handler(newDetails) {
        this.updateLocalFileDetails(newDetails);
      },
    },
  },
  methods: {
    updatePrintType(type) {
      this.localFileDetails.printType = type;
      this.calculatePrice();
    },
    updateRectoVerso(isRectoVerso) {
      this.localFileDetails.rectoverso = isRectoVerso;
      this.calculatePrice();
    },
    calculatePrice() {
      if (this.localFileDetails && this.localFileDetails.pages) {
        const basePrice =
          this.localFileDetails.printType === "color"
            ? this.fileDetails.price_color
            : this.fileDetails.price_bw;

        // Application du prix en fonction de rectoverso
        this.localFileDetails.price = this.localFileDetails.rectoverso
          ? basePrice * 1
          : basePrice;
      }

      // Émission des changements au parent via un événement
      this.$emit("update-fileDetails", { ...this.localFileDetails });
    },

    updateLocalFileDetails(newDetails) {
      // Mettre à jour uniquement si les données changent pour éviter les cycles
      if (
        JSON.stringify(this.localFileDetails) !== JSON.stringify(newDetails)
      ) {
        this.localFileDetails = {
          ...newDetails,
          printType: this.localFileDetails.printType,
          rectoverso: this.localFileDetails.rectoverso,
          price: this.localFileDetails.price,
          selectedPrinter: this.selectedPrinter,
        };
        this.calculatePrice();
      }
    },
  },
};
</script>
